






import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import AutoSaveConfiguration from '@/components/UserPreferences/AutoSaveConfiguration.vue';

export default Vue.extend({
  name: 'UserPreferences',
  data() {
    return {};
  },
  components: {
    LoadingSpinner,
    AutoSaveConfiguration
  }
});
